import { InvoiceFormats, InvoiceFormat } from '../types/invoice-format.type';
import { InvoiceTemplateId, InvoiceTemplateIds } from '../types/invoice-template-id.type';

export const INVOICE_TEMPLATE_ALLOWED_FORMATS: Record<InvoiceTemplateId, readonly InvoiceFormat[]> = {
  [InvoiceTemplateIds.STANDARD]: [InvoiceFormats.PDF, InvoiceFormats.XLSX],
  [InvoiceTemplateIds.ADVANCED]: [InvoiceFormats.PDF, InvoiceFormats.XLSX],
  [InvoiceTemplateIds.EXPERT]: [InvoiceFormats.ZIP],
};
